import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { getToken } from "../lib/api";
import { connectSocket, disconnectSocket } from "../lib/socket";

// Opens the realtime socket while logged in and refreshes cached data on live events.
export function SocketBridge() {
  const { user } = useAuth();
  const qc = useQueryClient();

  useEffect(() => {
    const token = getToken();
    if (!user || !token) {
      disconnectSocket();
      return;
    }
    const s = connectSocket(token);
    if (!s) return;
    const invalidate = () => {
      qc.invalidateQueries({ queryKey: ["orders"] });
      qc.invalidateQueries({ queryKey: ["notifications"] });
      qc.invalidateQueries({ queryKey: ["admin-live-orders"] });
    };
    const onNotif = (n) => {
      invalidate();
      if (n?.title) toast(n.title, { description: n.body });
    };
    s.on("notification", onNotif);
    s.on("order_update", invalidate);
    s.on("admin_orders_changed", invalidate);
    return () => {
      s.off("notification", onNotif);
      s.off("order_update", invalidate);
      s.off("admin_orders_changed", invalidate);
    };
  }, [user, qc]);

  return null;
}
